<template>
  <div class="content">
        <div class="shell">
            <div class="book-preview-list">

                <div
                    class="book-preview-list__item"
                    v-for="article in articles"
                    :key="article.id"
                >
                    <book-preview
                        :rating="article.rating"
                        :title="article.title"
                        :coverSrc="article.cover"
                        :url="article.url"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import BookPreview from '@/components/book-preview/book-preview';

export default {
    name: 'CategoryFiction',

    components: {
        BookPreview
    },

    setup() {
        const articles = ref([
            {
                id: 1,
                rating: '5.0',
                title: 'The Forgotten Hours',
                cover: require('@/assets/images/temp/book-1.png'),
                url: '/book/1'
            },
            {
                id: 2,
                rating: '',
                title: 'Whiskey in a Teacup',
                cover: require('@/assets/images/temp/book-2.png'),
                url: '/book/1'
            },
            {
                id: 3,
                rating: '5.0',
                title: 'Has anyone been living in',
                cover: require('@/assets/images/temp/article-6.png'),
                url: '/book/1'
            },
            {
                id: 4,
                rating: '4.5',
                title: 'Do you have the experience',
                cover: require('@/assets/images/temp/article-5.png'),
                url: '/book/1'
            },
            {
                id: 5,
                rating: '',
                title: 'The Vocabulary of Style',
                cover: require('@/assets/images/temp/article-7.png'),
                url: '/book/1'
            },
            {
                id: 6,
                rating: '4.5',
                title: ' Still do it?',
                cover: require('@/assets/images/temp/article-4.png'),
                url: '/book/1'
            },
            {
                id: 7,
                rating: '',
                title: 'The expectations',
                cover: require('@/assets/images/temp/article-9.png'),
                url: '/book/1'
            },
            {
                id: 8,
                rating: '',
                title: 'Anne Brigman',
                cover: require('@/assets/images/temp/book-3.png'),
                url: '/book/1'
            },
            {
                id: 9,
                rating: '4.0',
                title: 'In your feelings',
                cover: require('@/assets/images/temp/article-8.png'),
                url: '/book/1'
            }
        ]);

        return {
            articles
        }
    }
}
</script>
